/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateIdentityProviderConnectionRequestBody,
  CreateIdentityProviderConnectionRequestBody$Outbound,
  CreateIdentityProviderConnectionRequestBody$outboundSchema,
} from "../components/createidentityproviderconnectionrequestbody.js";

export type CreateIdentityProviderConnectionSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CreateIdentityProviderConnectionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  createIdentityProviderConnectionRequestBody:
    CreateIdentityProviderConnectionRequestBody;
};

/** @internal */
export type CreateIdentityProviderConnectionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateIdentityProviderConnectionSecurity$outboundSchema:
  z.ZodMiniType<
    CreateIdentityProviderConnectionSecurity$Outbound,
    CreateIdentityProviderConnectionSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function createIdentityProviderConnectionSecurityToJSON(
  createIdentityProviderConnectionSecurity:
    CreateIdentityProviderConnectionSecurity,
): string {
  return JSON.stringify(
    CreateIdentityProviderConnectionSecurity$outboundSchema.parse(
      createIdentityProviderConnectionSecurity,
    ),
  );
}

/** @internal */
export type CreateIdentityProviderConnectionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  CreateIdentityProviderConnectionRequestBody:
    CreateIdentityProviderConnectionRequestBody$Outbound;
};

/** @internal */
export const CreateIdentityProviderConnectionRequest$outboundSchema:
  z.ZodMiniType<
    CreateIdentityProviderConnectionRequest$Outbound,
    CreateIdentityProviderConnectionRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      createIdentityProviderConnectionRequestBody:
        CreateIdentityProviderConnectionRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        createIdentityProviderConnectionRequestBody:
          "CreateIdentityProviderConnectionRequestBody",
      });
    }),
  );

export function createIdentityProviderConnectionRequestToJSON(
  createIdentityProviderConnectionRequest:
    CreateIdentityProviderConnectionRequest,
): string {
  return JSON.stringify(
    CreateIdentityProviderConnectionRequest$outboundSchema.parse(
      createIdentityProviderConnectionRequest,
    ),
  );
}
